// =================== CÓDIGO ORIGINAL SIN CAMBIOS ===================
// Seleccionamos todos los elementos con la clase 'toggle'
document.querySelectorAll('.toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function(event) {
        event.preventDefault(); // Prevenir el comportamiento por defecto del enlace
        this.classList.toggle('active'); // Alternar la clase 'active'
        
        // Buscar la sub-lista asociada y alternar su visibilidad
        let subList = this.nextElementSibling;
        if (subList.style.display === "block") {
            subList.style.display = "none";
        } else {
            subList.style.display = "block";
        }
    });
});

let selectedWaist = null;
let selectedInseam = null;

// Función para seleccionar la variante basada en waist y inseam
function selectVariant() {
    if (selectedWaist && selectedInseam) {
        const variantValue = `${selectedWaist}/${selectedInseam}`;
        const variantInput = document.querySelector(`input[type="radio"][value="${variantValue}"]`);
        
        if (variantInput) {
            variantInput.click();
            variantInput.checked = true;
            console.log('Variant found:', variantValue);
        } else {
            console.log('Variant not found:', variantValue);
        }
    }
}

// Function to update the availability of inseam options based on the selected waist
function updateInseamOptions() {
    const inseamItems = document.querySelectorAll('.sub-list.inseam li');
    inseamItems.forEach(item => {
        const inseamValue = item.getAttribute('data-inseam');
        const variantValue = `${selectedWaist}/${inseamValue}`;
        const variantInput = document.querySelector(`input[type="radio"][value="${variantValue}"]`);

        if (variantInput && (variantInput.disabled || variantInput.classList.contains('disabled'))) {
            item.classList.add('disabled');
            item.classList.remove('available');
        } else if (variantInput) {
            item.classList.remove('disabled');
            item.classList.add('available');
        } else {
            item.classList.add('disabled');
            item.classList.remove('available');
        }
    });
}

// Listener para las opciones de waist
document.querySelectorAll('.sub-list.waist li').forEach(function (item) {
    item.addEventListener('click', function () {
    // Remove 'active' class from all items
    document.querySelectorAll('.sub-list.waist li').forEach(i => i.classList.remove('active'));
    // Add 'active' class to the clicked item

    // Capturar el valor del item seleccionado
    const selectedValue = this.textContent.trim();
        
    // Cerrar el colapso automáticamente
    //const subList = this.closest('.sub-list');
    //subList.style.display = 'none';

    // Añadir o actualizar el span con el valor seleccionado
    let waistSelectedSpan = document.getElementById("waist-value-selected");
   
    waistSelectedSpan.textContent = ':  ' + selectedValue;

    this.classList.add('active');
    selectedWaist = this.getAttribute('data-waist');
    updateInseamOptions(); // Update inseam options based on selected waist
    selectVariant();
    });
});

// Listener para las opciones de inseam
document.querySelectorAll('.sub-list.inseam li').forEach(function (item) {
    item.addEventListener('click', function () {
    // Remove 'active' class from all items
    document.querySelectorAll('.sub-list.inseam li').forEach(i => i.classList.remove('active'));
    // Add 'active' class to the clicked item

     // Capturar el valor del item seleccionado
     const selectedValue = this.textContent.trim();
        
     // Cerrar el colapso automáticamente
     //const subList = this.closest('.sub-list');
     //subList.style.display = 'none';

     // Añadir o actualizar el span con el valor seleccionado
    let inseamSelectedSpan = document.getElementById("inseam-value-selected");
    inseamSelectedSpan.textContent = ':  ' + selectedValue;

    this.classList.add('active');
    selectedInseam = this.getAttribute('data-inseam');
    selectVariant();
    });
});

// =================== FUNCIONES GLOBALES INDEPENDIENTES ===================
// Variables globales explícitas
window.globalSelectedWaist = null;
window.globalSelectedInseam = null;

// Función para toggle con logs de depuración
window.quickToggle = function(element) {
    console.log("quickToggle ejecutado en elemento:", element);
    
    try {
        // Alternar clase active
        element.classList.toggle('active');
        
        // Buscar la sublista y alternar visibilidad
        var subList = element.nextElementSibling;
        console.log("Sublista encontrada:", subList);
        
        if (subList && subList.classList.contains('sub-list')) {
            if (subList.style.display === "block") {
                subList.style.display = "none";
                console.log("Ocultando sublista");
            } else {
                subList.style.display = "block";
                console.log("Mostrando sublista");
            }
        }
    } catch (error) {
        console.error("Error en quickToggle:", error);
    }
    
    // Prevenir comportamiento predeterminado
    if (event) event.preventDefault();
    return false;
};

// Función para waist con logs de depuración
window.quickWaist = function(element) {
    console.log("quickWaist ejecutado en elemento:", element);
    
    try {
        // Remover clase active de todos los items
        var allWaistItems = document.querySelectorAll('.sub-list.waist li');
        console.log("Items waist encontrados:", allWaistItems.length);
        
        allWaistItems.forEach(function(item) {
            item.classList.remove('active');
        });
        
        // Añadir clase active al item clickeado
        element.classList.add('active');
        
        // Capturar valor del item seleccionado
        var selectedValue = element.textContent.trim();
        console.log("Valor seleccionado:", selectedValue);
        
        // Actualizar span con valor seleccionado
        var waistSelectedSpan = document.getElementById("waist-value-selected");
        if (waistSelectedSpan) {
            waistSelectedSpan.textContent = ':  ' + selectedValue;
            console.log("Span actualizado");
        } else {
            console.log("No se encontró el span waist-value-selected");
        }
        
        // Actualizar variable global
        window.globalSelectedWaist = element.getAttribute('data-waist');
        console.log("Waist seleccionado:", window.globalSelectedWaist);
        
        // Actualizar opciones de inseam
        window.quickUpdateInseam();
        
        // Seleccionar variante
        window.quickSelectVariant();
    } catch (error) {
        console.error("Error en quickWaist:", error);
    }
    
    // Prevenir comportamiento predeterminado
    if (event) event.preventDefault();
    return false;
};

// Función para inseam con logs de depuración
window.quickInseam = function(element) {
    console.log("quickInseam ejecutado en elemento:", element);
    
    try {
        // Remover clase active de todos los items
        var allInseamItems = document.querySelectorAll('.sub-list.inseam li');
        console.log("Items inseam encontrados:", allInseamItems.length);
        
        allInseamItems.forEach(function(item) {
            item.classList.remove('active');
        });
        
        // Añadir clase active al item clickeado
        element.classList.add('active');
        
        // Capturar valor del item seleccionado
        var selectedValue = element.textContent.trim();
        console.log("Valor seleccionado:", selectedValue);
        
        // Actualizar span con valor seleccionado
        var inseamSelectedSpan = document.getElementById("inseam-value-selected");
        if (inseamSelectedSpan) {
            inseamSelectedSpan.textContent = ':  ' + selectedValue;
            console.log("Span actualizado");
        } else {
            console.log("No se encontró el span inseam-value-selected");
        }
        
        // Actualizar variable global
        window.globalSelectedInseam = element.getAttribute('data-inseam');
        console.log("Inseam seleccionado:", window.globalSelectedInseam);
        
        // Seleccionar variante
        window.quickSelectVariant();
    } catch (error) {
        console.error("Error en quickInseam:", error);
    }
    
    // Prevenir comportamiento predeterminado
    if (event) event.preventDefault();
    return false;
};

// Función para actualizar disponibilidad de inseam
window.quickUpdateInseam = function() {
    console.log("quickUpdateInseam ejecutado");
    
    try {
        if (!window.globalSelectedWaist) {
            console.log("No hay waist seleccionado");
            return;
        }
        
        var inseamItems = document.querySelectorAll('.sub-list.inseam li');
        console.log("Actualizando disponibilidad para", inseamItems.length, "items de inseam");
        
        inseamItems.forEach(function(item) {
            var inseamValue = item.getAttribute('data-inseam');
            var variantValue = window.globalSelectedWaist + '/' + inseamValue;
            var variantInput = document.querySelector('input[type="radio"][value="' + variantValue + '"]');
            
            if (variantInput && (variantInput.disabled || variantInput.classList.contains('disabled'))) {
                item.classList.add('disabled');
                item.classList.remove('available');
                console.log("Inseam", inseamValue, "deshabilitado");
            } else if (variantInput) {
                item.classList.remove('disabled');
                item.classList.add('available');
                console.log("Inseam", inseamValue, "habilitado");
            } else {
                item.classList.add('disabled');
                item.classList.remove('available');
                console.log("Inseam", inseamValue, "deshabilitado (no se encontró variante)");
            }
        });
    } catch (error) {
        console.error("Error en quickUpdateInseam:", error);
    }
};

// Función para seleccionar variante
window.quickSelectVariant = function() {
    console.log("quickSelectVariant ejecutado");
    
    try {
        if (!window.globalSelectedWaist || !window.globalSelectedInseam) {
            console.log("No hay waist o inseam seleccionado");
            return;
        }
        
        var variantValue = window.globalSelectedWaist + '/' + window.globalSelectedInseam;
        console.log("Buscando variante:", variantValue);
        
        var variantInput = document.querySelector('input[type="radio"][value="' + variantValue + '"]');
        
        if (variantInput) {
            variantInput.click();
            variantInput.checked = true;
            console.log("Variante encontrada y seleccionada:", variantValue);
        } else {
            console.log("Variante no encontrada:", variantValue);
        }
    } catch (error) {
        console.error("Error en quickSelectVariant:", error);
    }
};

// Log inicial para confirmar que el script se ha cargado
console.log("Funciones globales para selector de tallas inicializadas");